// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Ssh","type":"styles_type__ciANF","choices":"styles_choices__23DKa"};